
import { createRepo } from '../repo';
import { DriverRefueling } from '../../types';
import { DB_KEYS } from '../dbKeys';

import { cloudSync } from '../sync/CloudSyncService';
import { encrypt, decrypt } from '../security/encryption';

const refuelingRepo = createRepo<DriverRefueling>('refuelings', {
    cloudCollection: 'refuelings',
    beforeCloudSync: async (item) => {
        const security = await cloudSync.getEncryptionParams();

        // Encrypt PII: notes (supplierName and other fields are not PII)
        const notes = (security && item.notes)
            ? await encrypt(item.notes, security.key || security.password, security.salt)
            : item.notes;

        return {
            ...item,
            notes: notes ?? null,
            updatedAt: new Date().toISOString()
        };
    }
});

export const getRefuelings = async () => (await refuelingRepo.list({ pageSize: 1000 })).data;
export const fetchRefuelings = async (q: any) => refuelingRepo.list(q);
export const createRefueling = async (item: Omit<DriverRefueling, 'id' | 'status' | 'createdAt'>) => {
    return refuelingRepo.create({
        ...item,
        status: 'pending',
        createdAt: new Date().toISOString()
    });
};
export const updateRefueling = async (id: string, patch: Partial<DriverRefueling>) => refuelingRepo.update(id, patch);
export const deleteRefueling = async (id: string) => refuelingRepo.remove(id);

export const refuelingService = {
    ...refuelingRepo,
    getAll: async () => (await refuelingRepo.list({ pageSize: 10000 })).data,
    create: createRefueling,
    update: updateRefueling,
    delete: deleteRefueling,
    async upsertFromCloud(items: any[]) {
        if (items.length === 0) return;
        const security = await cloudSync.getEncryptionParams();

        const processedItems = await Promise.all(items.map(async (item) => {
            // Decrypt PII: notes
            if (security && item.notes && typeof item.notes === 'string' && item.notes.includes(':')) {
                try {
                    const decrypted = await decrypt(item.notes, security.key || security.password, security.salt);
                    if (decrypted) item.notes = decrypted;
                } catch (e) { }
            }
            return item as DriverRefueling;
        }));

        await refuelingRepo.updateBulk(processedItems, true);
    }
};
